import * as React from 'react';

import { Icon, IconButton as ChakraIconButton } from '@chakra-ui/react';
import { Close } from '@m/icons';

import type { ButtonProps } from '@chakra-ui/react';

export type CloseButtonProps = ButtonProps;

export const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>((props, ref) => (
  <ChakraIconButton variant="ghost" aria-label="Close" ref={ref} {...props}>
    {props.children ?? <Icon as={Close} />}
  </ChakraIconButton>
));
